import { jsx as e } from "@emotion/react/jsx-runtime";
import { useRef as m } from "react";
import { Bar as a } from "react-chartjs-2";
import { useChartContext as f } from "../ChartContext.js";
const u = () => {
  const r = m(null), {
    options: o,
    data: t
  } = f();
  return /* @__PURE__ */ e(a, { ref: r, options: o, data: t });
};
export {
  u as BarChart
};
